import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getPropertyTypeBankAcc = async (query, cancelToken) => {
  const { page, perPage } = query;
  const res = await realBricksApi.get(
    `${API_ENDPOINTS.FINANCE.GetBankAcc}?page=${page + 1}${
      perPage && `&&perPage=${perPage}`
    }`,
    {
      cancelToken
    }
  );
  return res.data;
};

export const addPropertyTypeBankAcc = async (body) => {
  const res = await realBricksApi.post(
    `${API_ENDPOINTS.FINANCE.AddBankAcc}`,
    body
  );
  return res.data;
};

// export const updatePropertyTypeBank = async (propertyId, body) => {
//   const res = await realBricksApi.put(
//     `${API_ENDPOINTS.FINANCE.massTransfer}/${propertyId}`,
//     body
//   );
//   return res.data;
// };

// export const fetchPropertyTypeBank = async (id, cancelToken) => {
//   const res = await realBricksApi.get(API_ENDPOINTS.FINANCE.GetSecondaryProperties,{cancelToken});
//   return res.data;
// };

export const verifyDeposits = async (id, body) => {
  const res = await realBricksApi.put(
    `${API_ENDPOINTS.FINANCE.VerifyDeposits}/${id}`,
    body
  );
  return res.data;
};

export const setMassTransfer = async (propertyId, body) => {
  const res = await realBricksApi.post(
    `${API_ENDPOINTS.FINANCE.massTransfer}/${propertyId}`,
    body
  );
  return res.data;
};

export const getSecondaryProperties = async (cancelToken) => {
  const res = await realBricksApi.get(API_ENDPOINTS.FINANCE.GetSecondaryProperties,{cancelToken});
  return res.data;
};

export const getDividendTransferList = async (currentPage, cancelToken,limit) => {
  const res = await realBricksApi.get(
    `${API_ENDPOINTS.FINANCE.GetDividendList}?page=${currentPage + 1}&limit=${limit}`,
    {cancelToken}
  );
  return res.data;
};